import { jsx, jsxs } from "react/jsx-runtime";
import {
  Canvas,
  TldrawEditor,
  defaultShapes,
  defaultTools
} from "@tldraw/editor";
import { ContextMenu, TldrawUi } from "@tldraw/ui";
import { useMemo } from "react";
function Tldraw(props) {
  const { children, ...rest } = props;
  const withDefaults = {
    ...rest,
    shapes: useMemo(() => [...defaultShapes, ...(rest.shapes ?? [])], [rest.shapes]),
    tools: useMemo(() => [...defaultTools, ...(rest.tools ?? [])], [rest.tools])
  };
  return /* @__PURE__ */ jsx(TldrawEditor, { ...withDefaults, children: /* @__PURE__ */ jsxs(TldrawUi, { ...withDefaults, children: [
    /* @__PURE__ */ jsx(ContextMenu, { children: /* @__PURE__ */ jsx(Canvas, {}) }),
    children
  ] }) });
}
export {
  Tldraw
};
//# sourceMappingURL=Tldraw.mjs.map
